<template>
  <!-- Without a url the tag is a plain label: inside a GrowArticleCard (itself a link) a nested <a> is invalid HTML and breaks hydration. -->
  <component
    :is="url ? CustomNuxtLink : 'span'"
    :to="url || undefined"
    data-component="GrowArticleTag"
    class="inline-flex items-center gap-2 rounded-sm bg-primary-100 px-2.5 py-1.5 text-[12px] leading-relaxed font-medium text-white max-w-full">
    <img
      v-if="icon?.src"
      :src="icon.src"
      :alt="icon.altText ?? ''"
      aria-hidden="true"
      class="w-4 h-4 object-contain invert shrink-0" >
    <!-- Keep the label on a single line; overflow gets an ellipsis (see max-w-full above + min-w-0 on the host li). -->
    <span class="truncate">{{ title }}</span>
  </component>
</template>

<script setup lang="ts">
import type { ImageApiModel } from '@gro-up/api/corporate'
import { CustomNuxtLink } from '@gro-up/ui/primitives'

export type GrowArticleTagProps = {
  title: string
  icon?: ImageApiModel | null
  url?: string | null
}

withDefaults(defineProps<GrowArticleTagProps>(), {
  icon: undefined,
  url: undefined,
})
</script>
